import { useState } from "react";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import { usePermissionsProvider } from "../../../auth/usePermissionsProvider";
import { GeneralTabContentProps } from "./GeneralTabContent";
import { SystemGeneralTabContentViewModel } from "./GeneralTabContent.types";

import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useGeneralTabContent(props: GeneralTabContentProps) {
    const [showSuppliers, setShowSuppliers] = useState(false);
    const [showSubSuppliers, setShowSubSuppliers] = useState(false);
    const { permissions } = useUserContext();
    const { hasEnterpriseRiskManagementAccess } = usePermissionsProvider();

    const queryKey = "systemOverview" + props.systemId + "genereltab";
    const infoQuery = useDotLegalQueryWithKey<SystemGeneralTabContentViewModel>(`${queryKey}`, `/SystemOverview/${props.systemId}/generaltab`);

    return {
        isLoading: infoQuery.isLoading,
        infoData: infoQuery.data,
        infoRefetch: infoQuery.refetch,
        showSubSuppliers,
        setShowSubSuppliers,
        permissions,
        hasEnterpriseRiskManagementAccess,
        showSuppliers,
        setShowSuppliers,
    };
}
